import { render, staticRenderFns } from "./DialogClaimSuccess.vue?vue&type=template&id=1ef6f1b6&scoped=true"
import script from "./DialogClaimSuccess.vue?vue&type=script&lang=js"
export * from "./DialogClaimSuccess.vue?vue&type=script&lang=js"
import style0 from "./DialogClaimSuccess.vue?vue&type=style&index=0&id=1ef6f1b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef6f1b6",
  null
  
)

export default component.exports